import { RootState } from 'rootReducer';

export const scanerSelector = (state: RootState) => state.commonReducer.scanerReducer;
export const scanerBtnSelector = (state: RootState) => ({
  error: state.commonReducer.scanerReducer.error,
  type: state.commonReducer.scanerReducer.typeDoc,
  idx: state.commonReducer.scanerReducer.index,
});
